import { ApplePayDisabledMedium } from '../assets/payment-methods/apple-pay-disabled-medium'
import { ApplePayDisabledSmall } from '../assets/payment-methods/apple-pay-disabled-small'
import { ApplePayEnabledMedium } from '../assets/payment-methods/apple-pay-enabled-medium'
import { ApplePayEnabledSmall } from '../assets/payment-methods/apple-pay-enabled-small'
import { BoletoDisabledMedium } from '../assets/payment-methods/boleto-disabled-medium'
import { BoletoDisabledSmall } from '../assets/payment-methods/boleto-disabled-small'
import { BoletoEnabledMedium } from '../assets/payment-methods/boleto-enabled-medium'
import { BoletoEnabledSmall } from '../assets/payment-methods/boleto-enabled-small'
import { GooglePayDisabledMedium } from '../assets/payment-methods/google-pay-disabled-medium'
import { GooglePayDisabledSmall } from '../assets/payment-methods/google-pay-disabled-small'
import { GooglePayEnabledMedium } from '../assets/payment-methods/google-pay-enabled-medium'
import { GooglePayEnabledSmall } from '../assets/payment-methods/google-pay-enabled-small'
import { NuPayDisabledMedium } from '../assets/payment-methods/nupay-disabled-medium'
import { NuPayDisabledSmall } from '../assets/payment-methods/nupay-disabled-small'
import { NuPayEnabledMedium } from '../assets/payment-methods/nupay-enabled-medium'
import { NuPayEnabledSmall } from '../assets/payment-methods/nupay-enabled-small'
import { PixDisabledMedium } from '../assets/payment-methods/pix-disabled-medium'
import { PixDisabledSmall } from '../assets/payment-methods/pix-disabled-small'
import { PixEnabledMedium } from '../assets/payment-methods/pix-enabled-medium'
import { PixEnabledSmall } from '../assets/payment-methods/pix-enabled-small'
import type { PaymentMethodFlagsProps } from '../flags.types'

const PaymentMethodFlags = (props: PaymentMethodFlagsProps) => {
  if (props.size === 'sm' && !props.disabled)
    switch (props.variant) {
      case 'apple-pay':
        return <ApplePayEnabledSmall />
      case 'boleto':
        return <BoletoEnabledSmall />
      case 'google-pay':
        return <GooglePayEnabledSmall />
      case 'nupay':
        return <NuPayEnabledSmall />
      case 'pix':
        return <PixEnabledSmall />
    }

  if (props.size === 'md' && !props.disabled)
    switch (props.variant) {
      case 'apple-pay':
        return <ApplePayEnabledMedium />
      case 'boleto':
        return <BoletoEnabledMedium />
      case 'google-pay':
        return <GooglePayEnabledMedium />
      case 'nupay':
        return <NuPayEnabledMedium />
      case 'pix':
        return <PixEnabledMedium />
    }

  if (props.size === 'sm' && props.disabled)
    switch (props.variant) {
      case 'apple-pay':
        return <ApplePayDisabledSmall />
      case 'boleto':
        return <BoletoDisabledSmall />
      case 'google-pay':
        return <GooglePayDisabledSmall />
      case 'nupay':
        return <NuPayDisabledSmall />
      case 'pix':
        return <PixDisabledSmall />
    }

  switch (props.variant) {
    case 'apple-pay':
      return <ApplePayDisabledMedium />
    case 'boleto':
      return <BoletoDisabledMedium />
    case 'google-pay':
      return <GooglePayDisabledMedium />
    case 'nupay':
      return <NuPayDisabledMedium />
    case 'pix':
      return <PixDisabledMedium />
  }
}

export default PaymentMethodFlags
